<template>
  <v-card flat>
    <v-row class="pr-3 mt-3">
      <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
        <v-date-picker
          no-title
          v-model="picker"
          locale="id"
          :picker-date.sync="pickerDate"
        ></v-date-picker>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
        <v-card outlined class="rounded-lg pa-1" v-if="schedule">
          <v-card-actions>
            <p class="ma-0 subtitle-2 font-weight-regular">
              <v-avatar color="#1792E6" size="10" class="mr-2"></v-avatar>
              <span class="font-weight-bold">{{ schedule.types }}</span>
              {{ schedule.check_in | time }} - {{ schedule.check_out | time }}
            </p>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import PegawaiService from "@/services/resources/pegawai.service";

export default {
  data() {
    return {
      id: this.$route.params ? this.$route.params.employeeId : null,
      currentDate: this.$moment(),
      picker: new Date().toISOString().substr(0, 10),
      pickerDate: null,
      schedules: []
    };
  },
  computed: {
    schedule() {
      return this.schedules.find(d =>
        this.$moment(d.schedule_date).isSame(this.picker)
      );
    }
  },
  watch: {
    pickerDate(val) {
      let year = this.$moment(val, "YYYY-MM").format("YYYY");
      let month = this.$moment(val, "YYYY-MM").format("MM");
      this.getSchedules(year, month);
    }
  },
  methods: {
    // Service
    async getSchedules(year, month) {
      try {
        this.loadingUnit = true;
        await PegawaiService.getSchedules(this.id, month, year)
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.schedules = data;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingUnit = false));
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.getSchedules(
      this.$options.filters.dateYear(this.currentDate),
      this.$options.filters.dateMonth(this.currentDate)
    );
  }
};
</script>
